module.exports = __webpack_public_path__ + "static/img/case_2.83fc4eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_2.jpg
// module id = ZOhC
// module chunks = 0